import styled from 'styled-components'

export const OutlineCard = styled.div`
  display: block;
  margin: 20px auto;
  max-width: 600px;
  padding: 0 32px;
  text-align: left;

  * {
    box-sizing: border-box;
  }
`

export const FormalizationContainer = styled.div`
  max-width: 1024px;
  margin: 0 auto 32px;

  .section {
    > div {
      max-width: 100% !important;
      > div {
        max-width: 100% !important;
      }
    }
  }

  .row {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 32px;
    margin: auto;

    &.flex-end {
      align-items: flex-end;
    }

    .space {
      padding-top: 16px;
    }

    .col {
      width: 50%;
    }
    .col-large {
      width: 60%;
    }
    .col-small {
      width: 40%;

      .DFtextField {
        margin-bottom: 0;
      }
    }
  }
`
export const FormalizationTableContainer = styled.div`
  margin-bottom: 32px;
  padding-bottom: 80px;

  .owner-data {
    background: #f39c12;
    color: #fff;
    letter-spacing: 1px;
    font-size: 10px;
    line-height: 1;
    font-weight: 500;
    padding: 4px 6px;
    display: inherit;
  }

  .label {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.02em;
    font-weight: 700;
    color: #666;
  }

  .container {
    max-width: 1024px;
    margin: auto;
  }

  .row {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 32px;
    margin: auto;

    .col {
      width: 50%;
    }
  }

  .consents-container {
    padding-left: 44px;
    width: 100%;
    white-space: normal;
    font-family: Ubuntu, sans-serif;
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #6e6e6e;
    text-align: left;
  }
`

export const OutlineCardTitle = styled.div`
  display: block;
  max-width: 600px;

  * {
    box-sizing: border-box;
  }
`
export const OutlineCardContainer = styled.div`
  display: block;
  max-width: 600px;

  * {
    box-sizing: border-box;
  }
`
export const PlusLinkContainer = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  > div {
    padding: 0;
  }
`
export const Container = styled.div`
  display: block;
  padding: 0 16px 32px;
  .submitButton {
    margin: 15px 15px 5px auto;
  }
  .legal-container {
    max-width: 600px;
    width: 100%;
    margin: auto;

    * {
      box-sizing: border-box;
    }
  }
`

export const RadioButtonContainer = styled.div`
  text-align: left;
  > div {
    margin: 0px;
  }
  .DFradioFieldWrapper {
    span {
      > div {
        display: flex;
      }
    }
  }
  .DFradioField {
    label {
      text-align: left;
    }
  }
`

export const CheckBoxContainer = styled.div`
  .DFcontainer {
    padding-left: 0px;
  }
`
